import { ChronoUnit } from 'js-joda';
import { LayoutConfig } from './LayoutConfig';

const minutesInDay = 24 * 60;

/**
 * Minutes from the schedule start to the schedule end. Start == end means a
 * 24-hour schedule; an end before the start wraps past midnight (mirrors
 * `calculateTimeSlots`).
 */
export const scheduleLength = ({ startTime, endTime }: LayoutConfig): number =>
  startTime.equals(endTime)
    ? minutesInDay
    : (startTime.until(endTime, ChronoUnit.MINUTES) + minutesInDay) % minutesInDay;
